import {
	useEffect,
	useState
}
from "react";

import {
	useParams
}
from "react-router-dom";

import styled
from "styled-components";

import {
	useAuth
}
from "../contextos/AuthContext";

import calcularMapaComponente
from "../funciones/calcularMapaComponente";

import { useNavigate } from "react-router-dom";

const ComponentePortal = () => {

	const { usuario } =
		useAuth();

	const {
		id,
		codigo
	} = useParams();

	const navigate = useNavigate();

	const tipoQuiz = {

		icfes: "Examen_Icfes",
	
		unal: "Examen_Unal",
	
		udea: "Examen_Udea"
	
	}[codigo];

	const [
		temas,
		setTemas
	] = useState([]);

	useEffect(() => {

		const cargar =
		async () => {

			if (
				!usuario
			) return;

			const resultado =
				await calcularMapaComponente(
					usuario.uid,
					id
				);

			setTemas(
				resultado
			);
		};

		cargar();

	}, [
		usuario,
		id
	]);

	const niveles = {};

	temas.forEach(
		t => {

			if (
				!niveles[
					t.nivel
				]
			) {

				niveles[
					t.nivel
				] = [];
			}

			niveles[
				t.nivel
			].push(t);
		}
	);

	return (

		<Contenedor>

			<Titulo>

				🗺️ Región

			</Titulo>

			{
				Object.entries(
					niveles
				)
				.map(
					(
						[
							nivel,
							lista
						]
					) => (

						<Zona
							key={nivel}
						>

							<h2>

								Nivel {nivel}

							</h2>

							<Fila>

								{
									lista.map(
										tema => (

											<TemaCard
												key={tema.id}

												onClick={() => {

													navigate(
														`/meta/${codigo}/componente/${id}/tema/${tema.id}`
													);
												
												}}
											>

												<div>

													{
														tema.estado ===
														"dominado"
															? "🔥"

														: tema.estado ===
														"explorando"
															? "📡"

														: tema.estado ===
														"bloqueado"
															? "🔒"

														: tema.estado ===
														"critico"
															? "☣️"

														: "⚪"
													}

												</div>

												<div>

													{
														tema.nombre
													}

												</div>

											</TemaCard>
										)
									)
								}

							</Fila>

						</Zona>
					)
				)
			}

		</Contenedor>
	);
};

export default
	ComponentePortal;

const Contenedor =
styled.div`

	padding: 2rem;

	color: white;
`;

const Titulo =
styled.h1`

	margin-bottom: 2rem;
`;

const Zona =
styled.div`

	margin-bottom: 2rem;
`;

const Fila =
styled.div`

	display: flex;

	flex-wrap: wrap;

	gap: 1rem;
`;

const TemaCard =
styled.div`

	width: 220px;

	padding: 1rem;

	border-radius: 18px;

	background:
		rgba(
			255,
			255,
			255,
			0.08
		);

	text-align: center;
`;